/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/swiperSlider.js ***!
  \***************************************/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
    this.isSyncing = false;
  }
  connectedCallback() {
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initialize());
    } else {
      requestAnimationFrame(() => {
        setTimeout(() => this.initialize(), 50);
      });
    }
  }
  initialize(force = false) {
    if (this.swiperInstance && !force) {
      return;
    }
    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer || typeof Swiper === 'undefined') {
      console.warn('SwiperSlider: Swiper container or Swiper library not found');
      return;
    }
    const config = {
      watchOverflow: true,
      spaceBetween: parseInt(this.dataset.spaceBetween) || 10,
      grabCursor: true,
      slideToClickedSlide: true,
      loop: this.dataset.loop === 'true',
      centeredSlides: this.dataset.centeredSlides === 'true' ? true : false,
      direction: this.dataset.direction || 'horizontal'
    };
    const breakpoints = {};
    const mobileSlidesRaw = this.dataset.slidesMobile || this.dataset.slidesPerView || '1';
    const mobileSlides = mobileSlidesRaw === 'auto' ? 'auto' : parseFloat(mobileSlidesRaw) || 1;
    const mobileSpace = parseInt(this.dataset.spaceMobile) || parseInt(this.dataset.spaceBetween) || 10;
    config.slidesPerView = mobileSlides;
    config.spaceBetween = mobileSpace;
    const tabletSlidesRaw = this.dataset.slidesTablet;
    const tabletSlides = tabletSlidesRaw ? tabletSlidesRaw === 'auto' ? 'auto' : parseFloat(tabletSlidesRaw) : null;
    const tabletSpace = this.dataset.spaceTablet ? parseInt(this.dataset.spaceTablet) : null;
    if (tabletSlides !== null) {
      breakpoints[750] = {
        slidesPerView: tabletSlides,
        spaceBetween: tabletSpace !== null ? tabletSpace : mobileSpace,
        centeredSlides: this.dataset.centeredSlidesTablet === 'true' ? true : false
      };
    }
    const desktopSlidesRaw = this.dataset.slidesDesktop;
    const desktopSlides = desktopSlidesRaw ? desktopSlidesRaw === 'auto' ? 'auto' : parseFloat(desktopSlidesRaw) : null;
    const desktopSpace = this.dataset.spaceDesktop ? parseInt(this.dataset.spaceDesktop) : null;
    if (desktopSlides !== null) {
      breakpoints[990] = {
        slidesPerView: desktopSlides,
        spaceBetween: desktopSpace !== null ? desktopSpace : mobileSpace,
        centeredSlides: this.dataset.centeredSlidesDesktop === 'true' ? true : false
      };
    }
    if (Object.keys(breakpoints).length > 0) {
      config.breakpoints = breakpoints;
    }
    if (this.dataset.breakpoints) {
      try {
        const customBreakpoints = JSON.parse(this.dataset.breakpoints);
        config.breakpoints = _objectSpread(_objectSpread({}, config.breakpoints), customBreakpoints);
      } catch (e) {
        console.warn('SwiperSlider: Invalid breakpoints JSON:', e);
      }
    }
    const nextButton = this.querySelector('.swiper-button-next');
    const prevButton = this.querySelector('.swiper-button-prev');
    if (nextButton || prevButton) {
      config.navigation = {
        nextEl: nextButton,
        prevEl: prevButton,
        watchOverflow: this.dataset.galleryThumbnails !== 'true',
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden'
      };
    }
    const paginationEl = this.querySelector('.swiper-pagination');
    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true,
        type: 'bullets'
      };
    }
    if (this.dataset.galleryThumbnails === 'true') {
      config.allowTouchMove = true;
      config.speed = 300;
      config.slideToClickedSlide = true;
      config.direction = this.dataset.direction || 'horizontal';
      config.freeMode = false;
      config.watchSlidesProgress = true;
      config.watchSlidesVisibility = true;
      config.watchOverflow = false;
      if (config.navigation) {
        config.navigation.watchOverflow = false;
      }
      const self = this;
      config.on = {
        init: function () {
          self.attachThumbnailClickHandlers();
          setTimeout(() => {
            if (self.swiperInstance) {
              if (self.swiperInstance.navigation) {
                self.swiperInstance.navigation.init();
                self.swiperInstance.navigation.update();
              }
              self.swiperInstance.update();
              self.swiperInstance.updateSlides();
              self.swiperInstance.updateSlidesClasses();
              const activeSlide = swiperContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                self.updateThumbnailActiveState(activeSlide);
              }
            }
          }, 100);
        },
        slideChange: function () {
          if (self.isSyncing) return;
          if (self.swiperInstance && self.swiperInstance.navigation) {
            self.swiperInstance.navigation.update();
          }
        },
        slideChangeTransitionEnd: function () {
          if (self.isSyncing) return;
          const activeIndex = self.swiperInstance.activeIndex;
          const activeSlide = self.swiperInstance.slides[activeIndex];
          if (activeSlide) {
            self.updateThumbnailActiveState(activeSlide);
            setTimeout(() => {
              if (!self.isSyncing) {
                self.syncMainViewerFromThumbnail(activeSlide);
              }
            }, 50);
          }
        },
        slideChangeTransitionStart: function () {
          if (self.swiperInstance && self.swiperInstance.navigation) {
            self.swiperInstance.navigation.update();
          }
        }
      };
    }
    if (this.dataset.galleryViewer === 'true') {
      config.slidesPerView = 1;
      config.spaceBetween = 0;
      config.allowTouchMove = true;
      config.speed = 300;
      config.breakpoints = {};
      const container = this.closest('media-gallery, .product__media-wrapper, .product__media, .product-gallery-wrapper-rs') || document.body;
      const thumbnailsSwiper = container.querySelector('swiper-slider[data-gallery-thumbnails="true"]');
      const self = this;
      if (thumbnailsSwiper) {
        const connectThumbs = () => {
          if (thumbnailsSwiper.swiperInstance) {
            config.thumbs = {
              swiper: thumbnailsSwiper.swiperInstance
            };
            self.initializeSwiperInstance(swiperContainer, config);
          } else {
            setTimeout(connectThumbs, 50);
          }
        };
        if (thumbnailsSwiper.swiperInstance) {
          config.thumbs = {
            swiper: thumbnailsSwiper.swiperInstance
          };
        } else {
          connectThumbs();
          return;
        }
      }
      config.on = {
        slideChange: () => {
          if (!self.swiperInstance) return;
          const activeIndex = self.swiperInstance.activeIndex;
          if (activeIndex !== undefined && activeIndex !== null) {
            const activeSlide = self.swiperInstance.slides[activeIndex];
            if (activeSlide) {
              self.playActiveMedia(activeSlide);
            }
          }
        },
        slideChangeTransitionEnd: () => {
          if (self.isSyncing) return;
          if (!self.swiperInstance) return;
          const activeIndex = self.swiperInstance.activeIndex;
          const activeSlide = self.swiperInstance.slides[activeIndex];
          if (activeSlide) {
            if (thumbnailsSwiper && thumbnailsSwiper.swiperInstance) {
              const thumbActiveSlide = thumbnailsSwiper.querySelector('.swiper-slide-thumb-active');
              if (thumbActiveSlide) {
                const thumbWrapper = thumbnailsSwiper.querySelector('.swiper-wrapper');
                if (thumbWrapper) {
                  const thumbActiveIndex = Array.from(thumbWrapper.children).indexOf(thumbActiveSlide);
                  if (thumbActiveIndex >= 0 && thumbnailsSwiper.swiperInstance.activeIndex !== thumbActiveIndex) {
                    thumbnailsSwiper.isSyncing = true;
                    thumbnailsSwiper.swiperInstance.slideTo(thumbActiveIndex, 0);
                    setTimeout(() => {
                      thumbnailsSwiper.isSyncing = false;
                    }, 100);
                  }
                  if (thumbActiveIndex >= 0) {
                    thumbnailsSwiper.updateThumbnailActiveState(thumbActiveSlide);
                  }
                }
              } else {
                if (thumbnailsSwiper.swiperInstance.activeIndex !== activeIndex) {
                  thumbnailsSwiper.isSyncing = true;
                  thumbnailsSwiper.swiperInstance.slideTo(activeIndex, 0);
                  setTimeout(() => {
                    thumbnailsSwiper.isSyncing = false;
                  }, 100);
                }
                const activeThumbnail = thumbnailsSwiper.swiperInstance.slides[activeIndex];
                if (activeThumbnail) {
                  thumbnailsSwiper.updateThumbnailActiveState(activeThumbnail);
                }
              }
            }
            self.dispatchEvent(new CustomEvent('slideChanged', {
              detail: {
                currentPage: activeIndex + 1,
                currentElement: activeSlide
              },
              bubbles: true
            }));
          }
        },
        init: () => {
          self.slider = swiperContainer;
          self.sliderItems = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
          setTimeout(() => {
            if (thumbnailsSwiper && thumbnailsSwiper.swiperInstance) {
              const thumbActiveSlide = thumbnailsSwiper.querySelector('.swiper-slide-thumb-active');
              if (thumbActiveSlide) {
                const thumbWrapper = thumbnailsSwiper.querySelector('.swiper-wrapper');
                if (thumbWrapper) {
                  const thumbActiveIndex = Array.from(thumbWrapper.children).indexOf(thumbActiveSlide);
                  if (thumbActiveIndex >= 0 && thumbnailsSwiper.swiperInstance.activeIndex !== thumbActiveIndex) {
                    thumbnailsSwiper.isSyncing = true;
                    thumbnailsSwiper.swiperInstance.slideTo(thumbActiveIndex, 0);
                    setTimeout(() => {
                      thumbnailsSwiper.isSyncing = false;
                    }, 100);
                  }
                  if (thumbActiveIndex >= 0) {
                    thumbnailsSwiper.updateThumbnailActiveState(thumbActiveSlide);
                  }
                }
              } else {
                if (!self.swiperInstance) return;
                const activeIndex = self.swiperInstance.activeIndex;
                if (thumbnailsSwiper.swiperInstance.activeIndex !== activeIndex) {
                  thumbnailsSwiper.isSyncing = true;
                  thumbnailsSwiper.swiperInstance.slideTo(activeIndex, 0);
                  setTimeout(() => {
                    thumbnailsSwiper.isSyncing = false;
                  }, 100);
                }
                const activeThumbnail = thumbnailsSwiper.swiperInstance.slides[activeIndex];
                if (activeThumbnail) {
                  thumbnailsSwiper.updateThumbnailActiveState(activeThumbnail);
                }
              }
            }
          }, 150);
          if (!self.swiperInstance) return;
          const activeIndex = self.swiperInstance.activeIndex;
          const activeSlide = self.swiperInstance.slides[activeIndex];
          if (activeSlide) {
            self.playActiveMedia(activeSlide);
            self.dispatchEvent(new CustomEvent('slideChanged', {
              detail: {
                currentPage: activeIndex + 1,
                currentElement: activeSlide
              },
              bubbles: true
            }));
          }
        }
      };
    }
    this.initializeSwiperInstance(swiperContainer, config);
  }
  initializeSwiperInstance(swiperContainer, config) {
    try {
      this.swiperInstance = new Swiper(swiperContainer, config);
      swiperContainer.swiperInstance = this.swiperInstance;
      if (this.dataset.galleryViewer === 'true' || this.dataset.galleryThumbnails === 'true') {
        if (!this.swiperInstance) {
          console.warn('SwiperSlider: Swiper instance not created properly');
        }
      }
    } catch (error) {
      console.error('SwiperSlider: Error initializing Swiper:', error);
    }
  }
  attachThumbnailClickHandlers() {
    if (this._thumbnailClickHandlersAttached) {
      return;
    }
    const thumbnailSlides = this.querySelectorAll('.swiper-slide');
    const clickHandler = e => {
      e.preventDefault();
      e.stopPropagation();
      const slide = e.currentTarget;
      if (slide && this.swiperInstance) {
        const wrapper = this.querySelector('.swiper-wrapper');
        if (wrapper) {
          const slideIndex = Array.from(wrapper.children).indexOf(slide);
          if (slideIndex >= 0 && slideIndex !== this.swiperInstance.activeIndex) {
            this.swiperInstance.slideTo(slideIndex, 300);
            this.syncMainViewerFromThumbnail(slide);
          } else if (slideIndex >= 0 && slideIndex === this.swiperInstance.activeIndex) {
            this.syncMainViewerFromThumbnail(slide);
          }
        }
      }
    };
    thumbnailSlides.forEach(slide => {
      slide.addEventListener('click', clickHandler);
    });
    this._thumbnailClickHandlers = clickHandler;
    this._thumbnailClickHandlersAttached = true;
  }
  syncMainViewerFromThumbnail(thumbnailSlide) {
    if (this.isSyncing) return;
    const mediaId = thumbnailSlide.dataset.target;
    if (!mediaId) return;
    const viewerId = this.dataset.galleryViewerId;
    if (!viewerId) return;
    const mainViewer = document.getElementById(viewerId);
    if (!mainViewer || !mainViewer.swiperInstance) return;
    const mainViewerContainer = mainViewer.querySelector('.swiper');
    if (!mainViewerContainer) return;
    const mainSlide = mainViewerContainer.querySelector(`.swiper-slide[data-media-id="${mediaId}"]`);
    if (!mainSlide) return;
    const mainWrapper = mainViewerContainer.querySelector('.swiper-wrapper');
    if (!mainWrapper) return;
    const slideIndex = Array.from(mainWrapper.children).indexOf(mainSlide);
    if (slideIndex >= 0 && slideIndex !== mainViewer.swiperInstance.activeIndex) {
      mainViewer.isSyncing = true;
      mainViewer.swiperInstance.slideTo(slideIndex, 300);
      setTimeout(() => {
        mainViewer.isSyncing = false;
      }, 350);
    }
  }
  updateThumbnailActiveState(activeThumbnail) {
    const allThumbnails = this.querySelectorAll('.swiper-slide button');
    allThumbnails.forEach(btn => btn.removeAttribute('aria-current'));
    const activeBtn = activeThumbnail.querySelector('button');
    if (activeBtn) {
      activeBtn.setAttribute('aria-current', 'true');
    }
  }
  playActiveMedia(activeSlide) {
    if (typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }
    const deferredMedia = activeSlide.querySelector('.deferred-media');
    if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
      deferredMedia.loadContent(false);
    }
  }
  reinitialize() {
    this._thumbnailClickHandlersAttached = false;
    if (this._thumbnailClickHandlers) {
      const thumbnailSlides = this.querySelectorAll('.swiper-slide');
      thumbnailSlides.forEach(slide => {
        slide.removeEventListener('click', this._thumbnailClickHandlers);
      });
      this._thumbnailClickHandlers = null;
    }
    if (this.swiperInstance) {
      try {
        this.swiperInstance.destroy(true, true);
      } catch (error) {
        console.warn('SwiperSlider: Error destroying Swiper instance:', error);
      }
      this.swiperInstance = null;
    }
    const updateAfterReinit = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.swiperInstance) {
            if (this.dataset.galleryViewer === 'true') {
              const container = this.closest('media-gallery, .product__media-wrapper, .product__media, .product-gallery-wrapper-rs') || document.body;
              const thumbnailsSwiper = container.querySelector('swiper-slider[data-gallery-thumbnails="true"]');
              if (this.swiperInstance.thumbs && thumbnailsSwiper && thumbnailsSwiper.swiperInstance) {
                this.swiperInstance.thumbs.swiper = thumbnailsSwiper.swiperInstance;
                this.swiperInstance.thumbs.update();
              }
            }
            if (this.swiperInstance.navigation) {
              this.swiperInstance.navigation.update();
            }
            if (this.dataset.galleryThumbnails === 'true') {
              this.attachThumbnailClickHandlers();
            }
            this.swiperInstance.update();
            this.swiperInstance.updateSlides();
            this.swiperInstance.updateSlidesClasses();
          }
        });
      });
    };
    if (this.dataset.galleryViewer === 'true') {
      const container = this.closest('media-gallery, .product__media-wrapper, .product__media, .product-gallery-wrapper-rs') || document.body;
      const thumbnailsSwiper = container.querySelector('swiper-slider[data-gallery-thumbnails="true"]');
      if (thumbnailsSwiper) {
        const waitForThumbnails = () => {
          if (thumbnailsSwiper.swiperInstance) {
            this.initialize(true);
            updateAfterReinit();
          } else {
            setTimeout(waitForThumbnails, 50);
          }
        };
        waitForThumbnails();
        return;
      }
    }
    this.initialize(true);
    updateAfterReinit();
  }
  disconnectedCallback() {
    if (this.swiperInstance) {
      try {
        this.swiperInstance.destroy(true, true);
      } catch (error) {
        console.warn('SwiperSlider: Error destroying Swiper instance:', error);
      }
      this.swiperInstance = null;
    }
  }
}
if (!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', SwiperSlider);
}
/******/ })()
;